export class TripTaskType {
  public id = ''

  public name = ''

  public code = ''
}
